import NavigationIcon from "@mui/icons-material/Navigation";
import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import { DialogHeader } from "components/Parts/Atoms/DialogHeader";
import { QRCodeSVG } from "qrcode.react";
import React from "react";
import styles from "./QRCodeView.module.scss";
import { QRCodeViewProps } from "./interfaces";

export const QRCodeView = React.memo((props: QRCodeViewProps) => {
  return (
    <>
      <Dialog
        style={props.style}
        className={props.className}
        open={props.open}
        onClose={props.onClose}
        aria-labelledby="qrcode-title"
        aria-describedby="qrcode-description"
        slotProps={{
          paper: { className: styles.dialogPaper },
          backdrop: { className: styles.backdrop }
        }}
      >
        <DialogHeader id="qrcode-title" icon={<NavigationIcon />} />
        <DialogContent id="qrcode-description">
          <QRCodeSVG
            value={props.content}
            level="H"
            size={256}
            className={styles.qrCode}
          />
        </DialogContent>
        <DialogActions className={styles.actions}>
          <Button
            variant="contained"
            className={styles.cancelButton}
            color="warning"
            onClick={props.onCloseClick}
          >
            閉じる
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
});
